import { BaseDto } from '@greco/util-dto';
import { PaymentDisputeStatus } from './payment-dispute-dto';

export class ClosePaymentDisputeDto extends BaseDto {
  status!: PaymentDisputeStatus;
  accountId!: string;
}
